import { AxiosResponse } from 'axios';
import { ON_FARM_PAYMENT_TRANSACTION_API_ENDPOINTS } from '../constants/apiEndpoints';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { StandardParams } from '../types/interfaces/apiParams.interfaces';
import { OnFarmPaymentTransaction, OnFarmPayOutstandingBalanceRequest } from '../types/interfaces/onFarmPaymentTransaction.interfaces';

export const getOnFarmPaymentTransactionsByAccountId = (
  accountId: number,
  params?: StandardParams,
): Promise<AxiosResponse<OnFarmPaymentTransaction[]>> => {
  return appContextGet(`${ON_FARM_PAYMENT_TRANSACTION_API_ENDPOINTS.ACCOUNT_}${accountId}`, params);
};

export const payOnFarmOutstandingBalance = (
  accountId: number,
  payload?: OnFarmPayOutstandingBalanceRequest,
): Promise<AxiosResponse<OnFarmPaymentTransaction>> => {
  return appContextPost(
    `${ON_FARM_PAYMENT_TRANSACTION_API_ENDPOINTS.ACCOUNTS_}${accountId}${ON_FARM_PAYMENT_TRANSACTION_API_ENDPOINTS.PAY}`,
    payload ?? {},
  );
};
